import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { CCloseButton, CSidebar, CSidebarHeader } from "@coreui/react-pro";
import { setAside } from "src/Slices/SideBarSlice";
import { useNavigate } from "react-router-dom";

const AppAside = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const asideShow = useSelector(({ sideBarState }) => sideBarState.asideShow);
  function clickHandlerLogout() {
    localStorage.clear();
    window.location.reload(false);
  }
  return (
    <CSidebar
      colorScheme="light"
      size="xl"
      overlaid
      placement="end"
      visible={asideShow}
      onVisibleChange={(visible) => {
        dispatch({ type: "set", asideShow: visible });
      }}
    >
      <CSidebarHeader className="bg-transparent">
        <CCloseButton
          className="float-end"
          onClick={() => dispatch(setAside(!asideShow))}
        />
      </CSidebarHeader>
      <button className="btn" onClick={clickHandlerLogout}>
        <div className="container">Oturumu Kapat</div>
      </button>
    </CSidebar>
  );
};

export default React.memo(AppAside);
